import React, { Component } from "react";
import "../style/style.css";

// Components
import Main from "./main-intro/";
// import Project from "./project";

class App extends Component {
  render() {
    return (
      <>
        <Main />
        {/* <Project /> comming soon */}
      </>
    );
  }
}

export default App;
